export default {
  header: {
    title: 'Share Commission',
  },
  breadcrumb: {
    root: 'Share',
  },
  tabs: {
    level1: 'Level 1 Customers',
    level2: 'Level 2 Customers',
    level3: 'Level 3 Customers',
  },
  filters: {
    keywordPlaceholder: 'Search Member ID, Nickname, Name',
    statusPlaceholder: 'Status',
    registerTime: 'Registration Time',
    query: 'Search',
    reset: 'Reset',
  },
  status: {
    rejected: 'Rejected',
    unsubmitted: 'Unsubmitted',
    pending: 'Pending',
    verified: 'Verified',
    uncompleted: 'Uncompleted',
  },
  actions: {
    detail: 'Detail',
  },
  columns: {
    memberId: 'Member ID',
    nickname: 'Nickname',
    realname: 'Full Name',
    country: 'Country',
    parentUser: 'Parent Info',
    total_number: 'Sub-customer Count',
    total_volume_million: 'Volume (lots)/Million USD',
    sale_commission: 'Total Commission',
    kycStatus: 'KYC Status',
    registerTime: 'Registration Time',
    operation: 'Operation',
  },
  summary: {
    totalCustomer: 'Total Customers',
    monthNew: 'New This Month',
    totalCommission: 'Total Commission',
  },
  stats: {
    totalCustomer: 'Total Customers',
    yesterdayCommission: 'Yesterday Commission',
    monthCommission: 'This Month Commission',
    totalCommission: 'Total Commission',
  },
  detail: {
    customerDetail: 'Customer Detail',
    tabs: {
      dayStatistics: 'Daily Statistics',
      commission: 'Commission Statistics',
    },
    clientInfo: {
      memberId: 'Member ID',
      nickName: 'Nickname',
      realName: 'Full Name',
      country: 'Country',
      parentInfo: 'Parent Info',
      level: 'Level',
      tradeVolume: 'Volume (lots)/Million USD',
      totalCommission: 'Total Commission',
      subCustomerCount: 'Sub-customers',
      registerTime: 'Registration Time',
    },
  },
  commissionDetail: {
    placeholders: {
      startTime: 'Start Time',
      endTime: 'End Time',
    },
    actions: {
      confirm: 'Confirm',
      reset: 'Reset',
    },
    tradeTypeOptions: {
      buy: 'Buy',
      sell: 'Sell',
    },
    statusText: {
      settled: 'Settled',
      pending: 'Pending',
    },
    columns: {
      orderId: 'Order ID',
      name: 'Full Name',
      tradeType: 'Trade Type',
      volumeMillion: 'Volume (lots)/Million USD',
      symbol: 'Symbol',
      price_position: 'Open Price',
      price: 'Close Price',
      commissionTime: 'Commission Time',
      commissionType: 'Commission Type',
      commissionAmount: 'Commission Amount',
      calculationFormula: 'Calculation Formula',
      status: 'Status',
      remark: 'Remark',
      openTime: 'Open Time',
      closeTime: 'Close Time',
    },
  },
  dayStatistics: {
    actions: {
      confirm: 'Confirm',
      reset: 'Reset',
      detail: 'Detail',
    },
    columns: {
      date: 'Date',
      volumeMillion: 'Volume (lots)/Million USD',
      commission: 'Commission',
    },
  },
  dateFormat: 'YYYY/MM/DD',
  dateTimeFormat: 'YYYY/MM/DD HH:mm:ss',
}
